import { render, staticRenderFns } from "./bidEvaluationMethodList.vue?vue&type=template&id=6d10b3ce&scoped=true"
import script from "./bidEvaluationMethodList.vue?vue&type=script&lang=js"
export * from "./bidEvaluationMethodList.vue?vue&type=script&lang=js"
import style0 from "./bidEvaluationMethodList.vue?vue&type=style&index=0&id=6d10b3ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10b3ce",
  null
  
)

export default component.exports